export default __webpack_public_path__ + "static/media/tt.669ed3e7.png";